import React, {useState, useEffect } from 'react'
import { Form, Button, Alert, Spinner, Col } from 'react-bootstrap'
import { connect } from 'react-redux'
import { handleExpiredAuthState } from '../../redux/actions/authActions'
import CandidatesApi from '../../api/CandidatesApi'
import { ApiException, ExpiredSessionException, ValidationException } from '../../api/exceptions'

const api = new CandidatesApi();

const MAX_NSS_LENGTH = 11;

const NssInput = ({ student, handleExpiredAuthState }) => {

  const { numero_de_seguro_social } = student.info
  const [nss, setNss] = useState('')
  const [isEnable, setIsEnable] = useState(false)
  const [message, setMessage] = useState({ status:'', message: ''})
  const [isLoading, setIsLoading] = useState(false)

  const { slug } = student.info
  const documento = student.documents.filter( document => document.slug === 'registro-imss')[0]

  const handleSubmit = () => {

    setIsLoading(true)

    api.setNss(slug, nss)
      .then( response => {
        setMessage({status: 'success', message: 'El número de seguro social se actualizó correctamente.'})
        setIsEnable(false)
        setIsLoading(false)
      } )
      .catch( error => {
        if(error instanceof ExpiredSessionException){
          return handleExpiredAuthState();
        }

        let message = 'Hubo un error al procesar la solicitud. Intente más tarde.';

        if (error instanceof ValidationException){
          message = error.errors.numero_de_seguro_social[0];
        } else if (error instanceof ApiException){
          message = error.message;
        }
        
        setMessage({status: 'danger', message: message})
        setIsLoading(false)
      })
      
  }

  const handleDisable = () => {
    setNss(numero_de_seguro_social)
    setIsEnable(false)
  }

  useEffect(() => {
    setNss(numero_de_seguro_social)
  }, [])

return(
    <Form>
      <Form.Control
        type="text"
        value={nss}
        onChange={(e) => setNss(e.target.value)} 
        placeholder="Número de Seguro Social"
        disabled={!isEnable}
        maxLength={MAX_NSS_LENGTH}
      />
      {
        !isEnable 
          ?<Button className="m-1" variant="info" onClick={() => setIsEnable(true) }><i className='fa fa-edit'></i></Button>
          :<>
            <Button className="m-1" variant="success" onClick={() => handleSubmit()}><i className='fa fa-save'></i></Button> 
            <Button className="m-1" variant="danger" onClick={() => handleDisable() }><i className='fa fa-times'></i></Button> 
          </>
      }
      <Col className='bg-white p-0'>
      {
        isLoading 
        ? <Spinner animation="border" variant="primary" /> 
        : message.message && (
          (<Alert variant={message.status}>
            { message.message }
          </Alert>) 
        ) 
      }
      </Col>
    </Form>
  )
}

const mapStateToProps = (state) => ({student: state.unenrolledStudentSelectedInfo})
const mapDispatchToProps = { handleExpiredAuthState }

export default connect(mapStateToProps,mapDispatchToProps)(NssInput)